import { Box, Paper, Typography } from "@mui/material";

export const panelSx = {
  border: "1px solid #e5e7eb",
  borderRadius: "8px",
  bgcolor: "#fff",
  boxShadow: "none",
};

export const OssPanel = ({ children, sx, className = "", ...props }) => (
  <Paper
    className={`oss-panel ${className}`}
    elevation={0}
    sx={{
      ...panelSx,
      ...sx,
    }}
    {...props}
  >
    {children}
  </Paper>
);

export const OssSectionPanel = ({ title, children, sx = {}, className = "" }) => (
  <OssPanel
    className={`oss-section-panel ${className}`}
    sx={{
      p: { xs: "16px", md: "20px" },
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      ...sx,
    }}
  >
    <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#283241", mb: "16px" }}>
      {title}
    </Typography>
    <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
      {children}
    </Box>
  </OssPanel>
);
